<script setup lang="ts">
import type { IFeatureItem } from '../../../models'
import { ElIcon, IconNames } from '../../icons'

interface TProps {
  model: IFeatureItem
}

const props = withDefaults(defineProps<TProps>(), {
  model: () => {
    return {
      key: 'not-set',
      iconName: IconNames.defaultIcon,
      header: '',
      text: '',
    }
  },
})

//<ElIcon :name="model.iconName" />
</script>

<template>
  <div class="relative pl-9 space-x-2">
    <div class="inline">
      <svg class="absolute left-1 top-1 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path
          fill-rule="evenodd"
          d="M5.5 17a4.5 4.5 0 01-1.44-8.765 4.5 4.5 0 018.302-3.046 3.5 3.5 0 014.504 4.272A4 4 0 0115 17H5.5zm3.75-2.75a.75.75 0 001.5 0V9.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0l-3.25 3.5a.75.75 0 101.1 1.02l1.95-2.1v4.59z"
          clip-rule="evenodd"
        />
      </svg>
      <span v-if="model.header" class="font-bold">
        {{ model.header }}
      </span>
    </div>
    <div v-if="model.text" class="inline font-light">
      {{ model.text }}
    </div>
  </div>
</template>
